import React from 'react';
import { targetIsDatepicker } from '../utils';
import { useTranslation } from 'react-i18next';
import { KEYS } from "@apps/Shared/Constants/KeyCodes";
import Icon from "@sharedComponents/Icon";
import { usePantameraService } from "@frontendUtils/pantamera-service";

const CustomDateInput = ({
                           datepickerProps,
                           onOpenCalendar,
                           onCloseCalendar,
                           inputRef,
                           value,
                           hasError,
                           disabled,
                           ...props
                         }: any) => {
  const { t } = useTranslation()
  const { getCssVariable } = usePantameraService();

  const onBlur = (e: any) => {
    if (!targetIsDatepicker(e.relatedTarget)) {
      onCloseCalendar()
    }
  }

  const whiteColour = getCssVariable('white');

  return (
    <div className={`custom-date-wrapper ${disabled ? 'custom-date-wrapper--disabled' : ''}`}>
      <label
        className={`custom-date__label ${datepickerProps.hideLabel ? 'sr-only' : ''}`}
        htmlFor={datepickerProps.id}
      >
        {datepickerProps.label}
        {datepickerProps.required ? '*' : ''}
      </label>
      <div
        className={`custom-date-wrapper__input-wrapper ${datepickerProps.className} ${
          hasError ? 'error' : ''
        }`}
      >
        <input
          {...props}
          value={value}
          onBlur={onBlur}
          ref={inputRef}
          placeholder={datepickerProps.placeholder || ''}
        />
        <div
          className='custom-date-wrapper__date-picker custom-datepicker-button'
          role="button"
          aria-label={t('label.openDatepicker')}
          tabIndex={0}
          onClick={onOpenCalendar}
          onKeyDown={e => {
            e.keyCode === KEYS.enter &&
            !disabled &&
            onOpenCalendar()
          }}
        >
          <Icon
            iconName="calendar"
            color={whiteColour}
            size={18}
          />
        </div>
      </div>
    </div>
  )
}

export default CustomDateInput;